// eslint-disable-next-line
import { GetOpenedAlertByCourse, getLocalWeather, getMicroWeather, getActiveTasks, getPrecipitationTotals, getStationMinMaxTemps } from '@/api/index';
import Vue from 'vue';
import { Mixin } from 'gw-js-lib';

export default {
  namespaced: true,
  state: { /* = data */
    localWeather: {},
    microWeather: [],
    precipitationTotals: {},
    alerts: [],
    tasks: [],
    selectedAlert: {},
    loading: {
      localWeather: false,
      microWeather: false,
      precipitationTotals: false,
      alerts: false,
      tasks: false,
      dailyTemps: false,
    },
    paginations: {
      tasks: {
        page: 1,
        rows: 100,
        order_by: 'orden asc, time_updated desc',
        filters: {
          // status: null,
        },
      },
    },
    dailyTemps: {},
  },

  getters: { /* = Computed properties, perfects to filter data an execute some calculation */
  },


  actions: { /* = Methods */

    async loadWeather({ commit, dispatch, state }) {
      commit('setLoading', {
        localWeather: true,
        microWeather: true,
      });

      getLocalWeather().then((localWeather) => {
        commit('setLocalWeather', localWeather);
        commit('setLoading', {
          localWeather: false,
        });
      });

      return getMicroWeather().then((microWeather) => {
        commit('setMicroWeather', microWeather);
        commit('setLoading', {
          microWeather: false,
        });
        // Both of these read state.microWeather, so they can only run once it has
        // landed. Dispatched in parallel from mounted() they raced it and threw.
        if (state.microWeather.length) {
          dispatch('loadPrecipitationTotals');
          dispatch('loadDailyTemps');
        }
      });
    },

    async loadPrecipitationTotals({ commit }) {
      commit('setLoading', { precipitationTotals: true });

      getPrecipitationTotals().then((precipitationTotals) => {
        if(precipitationTotals){
          commit('setPrecipitationTotals', precipitationTotals);
        }
        commit('setLoading', {
          precipitationTotals: false,
        });
      });

    },

    async loadAlerts({ commit }) {
      commit('setLoading', { alerts: true });

      await GetOpenedAlertByCourse().then((response) => {
        commit('setAlerts', response.alerts);
      }).finally(() => {
        commit('setLoading', { alerts: false });
      });
    },
    
    async loadTasks({ commit, state }) {
      commit('setLoading', { tasks: true });

      await getActiveTasks( ).then((tasks) => {
        commit('setTasks', tasks);
      }).finally(() => {
        commit('setLoading', { tasks: false });
      });
    },

    async loadDailyTemps({ commit, state }) {
      const station = state.microWeather && state.microWeather.length
        ? state.microWeather[0].station
        : null;

      // No microweather station assigned to this course - nothing to fetch.
      if (!station || !station.device_sn) {
        commit('setDailyTemps', {});
        return;
      }

      commit('setLoading', { dailyTemps: true });

      await getStationMinMaxTemps(station.device_sn).then((response) => {
        commit('setDailyTemps', (response && response[0]) || {});
      }).finally(() => {
        commit('setLoading', { dailyTemps: false });
      });
    },

  },

  mutations: { /* Mutations are responsible to change the state */
    setLocalWeather(state, localWeather) {
      state.localWeather = localWeather;
    },

    setMicroWeather(state, microWeather) {
      state.microWeather = Array.isArray(microWeather) ? microWeather : [];
    },

    setPrecipitationTotals(state, precipitationTotals) {
      const totals = Array.isArray(precipitationTotals) ? precipitationTotals : [];

      state.microWeather.forEach((weather, i) => {
        const match = totals.find(
          (precipitation) => precipitation.station
            && precipitation.station.station_id == weather.station.station_id,
        );

        // Vue.set: precipitation_totals is a new property on an existing object, so a
        // plain assignment is not reactive in Vue 2 and the popover never re-rendered.
        Vue.set(state.microWeather, i, {
          ...weather,
          precipitation_totals: match
            ? {
              week: match.week_total,
              month: match.month_total,
              quarter: match.quarter_total,
              year: match.year_total,
            }
            : { month: 0, quarter: 0, year: 0 },
        });
      });

      state.precipitationTotals = totals;
    },

    setDailyTemps(state, dailyTemps) {
      state.dailyTemps = dailyTemps
    },

    setAlerts(state, alerts) {
      state.alerts = alerts;
      setTimeout(()=> { Mixin.methods.G_triggerResizeEven(); }, 10);
    },
    setTasks(state, tasks) {
      state.tasks = tasks;
      setTimeout(()=> { Mixin.methods.G_triggerResizeEven(); }, 10);
    },
    setCourseId(state, CourseId) {
      state.paginations.tasks.filters.course_id = CourseId;
    },
    setSelectedAlert(state, alert) {
      state.selectedAlert = alert;
    },
    setLoading(state, loading) {
      state.loading = { ...state.loading, ...loading };
    },

  },

};
